import { Box } from "@chakra-ui/layout"
import React from "react"

import { SpacingSize } from "~/consts/style-mixins"

type ContainerSize = "Large" | "Medium" | "Small" // | "Full" |"XLarge"

type Props = {
  size: ContainerSize
  className?: string
}

// https://www.figma.com/file/88nwITOPgBhpR1FQLJPsM3/01-Components?node-id=57%3A150
export const Container: React.FC<Props> = ({ size, className, children }) => {
  return (
    <Box className={className} px={PADDING_X_MAP[size]}>
      <Box mx="auto" w="100%" maxW={MAX_WIDTH_MAP[size]}>
        {children}
      </Box>
    </Box>
  )
}

/**
 * @deprecated 以下のように{@link Container}を使う(互換性のため残してる)
 * ```tsx
 * <Container size="Large" />
 * ```
 */
export const ContainerLarge: React.FC<Omit<Props, "size">> = (props) => <Container {...props} size="Large" />

const PADDING_X_MAP: Record<ContainerSize, number> = {
  // Full: SpacingSize._2XL,
  // XLarge: SpacingSize.M,
  Large: SpacingSize.M,
  Medium: SpacingSize.M,
  Small: SpacingSize.M,
}

const MAX_WIDTH_MAP: Record<ContainerSize, string | undefined> = {
  // Full: undefined,
  // XLarge: "1200px",
  Large: "1000px",
  Medium: "640px",
  Small: "400px",
}
